import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import SearchResults from "@/pages/SearchResults";

export const Route = createFileRoute("/search")({ head: () => routeMeta('Search Mumbai Properties | MNRE', 'Search MNRE property listings by location, type, budget and configuration.', '/search'), component: SearchResults });
